import { Serializer } from "jsonapi-serializer";
import { ParentProfileInfo } from "../../api/typings/Profiles";
import { IApiResourceResponse } from "../../@typings/client";

export async function getUpdateParentData(
  profileInfo: ParentProfileInfo
): Promise<IApiResourceResponse<ParentProfileInfo>> {
  return new Serializer("users_profiles_parents", {
    keyForAttribute: "snake_case",
    attributes: ["about", "is_expired_subscription_payment_allowed"],
  }).serialize(profileInfo);
}
